import React, { useState, useEffect } from "react";
import useChatMessageStore from "../../../store/chatMessagesStore";
import FadeInText from "./../../../components/organisms/AnimatedText";

interface LoadingDotsProps {
  className?: string;
  projectName?: string;
  thinkingText?: string[];
}

const LoadingDots: React.FC<LoadingDotsProps> = ({
  className = "",
  projectName,
  thinkingText,
}) => {
  const [showError, setShowError] = useState(false);
  const { setReplyMessage, setIsAIResponding } = useChatMessageStore();

  useEffect(() => {
    // Set AI as responding when LoadingDots mounts (AI starts generating)
    // setIsAIResponding(true);

    const timer = setTimeout(() => {
      setShowError(true);
      setReplyMessage(null);
      setIsAIResponding(false); // Enable input when error occurs
    }, 60000 * 3); // 180 seconds

    // Cleanup function to ensure AI responding is set to false when component unmounts
    return () => {
      clearTimeout(timer);
      // setIsAIResponding(false); // Enable input when loading completes normally
    };
  }, [setReplyMessage, setIsAIResponding]);

  if (showError) {
    if (!navigator.onLine) {
      return (
        <div className={className}>
          No internet connection. Please check your network and try again.
        </div>
      );
    }
    return (
      <div className={className}>
        Could you please clarify what exactly you'd like to know about?
      </div>
    );
  }

  return <FadeInText projectName={projectName || ""} thinkingText={thinkingText} />;
};

export default LoadingDots;
